module.exports = __webpack_public_path__ + "static/media/selectedTextHover.d7c4fd2d.png";